module.exports = __webpack_public_path__ + "static/media/map-img.ca1d9304.png";